<template lang="pug">
.entity-expression-builder
  //- h1 entity-expression-builder
  v-row.justify-end
    v-btn.add-entity-button(@click="items.push({value: null, type: null})", fab, small, color="primary")
      v-icon mdi-plus
    v-col(cols="12")
      pre {{ expression }}
  v-row
    v-col.expression-item(v-for="(item, i) in items")
      v-btn.expression-item-reset(icon, @click="item.type = null", x-small)
        v-icon mdi-restore
      v-btn.expression-item-close(icon, @click="items.splice(i, 1)", x-small)
        v-icon mdi-close
      v-text-field(
        v-if="item.type === TYPES.TYPE_CONSTANT",
        v-model="item.value"
      )
      v-select(
        v-else-if="item.type === TYPES.TYPE_SYMBOL"
        :items="operators",
        v-model="item.value",
      )
      app-entity-path-selector(
        v-else-if="item.type === TYPES.TYPE_VARIABLE"
        ref="path-selector",
        :entity="entity",
        @field="item.value = $event.path",
        :extra-items="operators.map(o => ({ name: o, primitive: true }))"
       )
      v-select(
        v-else
        :items="[TYPES.TYPE_VARIABLE, TYPES.TYPE_SYMBOL, TYPES.TYPE_CONSTANT]",
        v-model="item.type",
       )
      //- v-switch(
        style="margin: 0px"
        v-model="item.type",
        :false-value="TYPES.TYPE_VARIABLE", 
        :true-value="TYPES.TYPE_SYMBOL",
        :label="item.type === TYPES.TYPE_SYMBOL ? 'symbol' : 'variable'"
       )
</template>
<style>
.expression-item-close {
  position: absolute;
  right: 0px;
}
.expression-item {
  position: relative
}
</style>
<script>
import EntityMixin from '@/mixins'
const TYPE_SYMBOL = 'SYMBOL'
const TYPE_VARIABLE = 'ENTITY VARIABLE'
const TYPE_CONSTANT = 'CONSTANT'
const TYPES = {
  TYPE_SYMBOL,
  TYPE_VARIABLE,
  TYPE_CONSTANT
} 
export default {
  mixins: [EntityMixin],
  props: ['entity'],
  data () {
    return {
      TYPES,
      items: [],
      operators: ['(', ')', '/', '-', '*', '%', '+', '=', '>=', '<=', '!='],
    }
  },
  methods: {
    //
  },
  watch: {
    expression() {
      this.$emit('expression', this.expression)
    }
  },
  computed: {
    expression() {
      return this.items.map(i => i.value).join(' ')
    }
  }
}
</script>